angular.module('impactx.cube').controller('CubeMenuCtrl', [
    'cubeMenu',
    CubeMenuCtrl]);

function CubeMenuCtrl(cubeMenu)
{
    var self = this;
    this.cubeMenu = cubeMenu;

    this.cubeMenu.refreshCubes().then(function()
    {
        self.editOptions = [{label: cubeMenu.actionTranslations.exportExcel, func: cubeMenu.exportCube},
            {label: cubeMenu.actionTranslations.sendMail, func: cubeMenu.sendCubeMail},
            {label: cubeMenu.actionTranslations.displayCube, func: cubeMenu.displayCube}];
    });

}